import React from "react";
import { Link } from "react-router-dom";
import { CardFooter } from "@/components/ui/card";

const UpgradeCardFooter = ({ isTrial }) => (
  <CardFooter className="text-xs text-muted-foreground text-center block space-y-2">
    {isTrial ? (
      <p>
        No payment information required.{" "}
        <Link to="/terms" className="underline font-medium">
          Trial Terms
        </Link>{" "}
        apply. You can cancel anytime before the trial ends.
      </p>
    ) : (
      <p>
        By continuing, you agree to our{" "}
        <Link to="/terms" className="underline">
          Terms of Service
        </Link>
        . Your subscription will auto-renew.
      </p>
    )}
    <Link
      to="/list-inventory"
      className="text-primary hover:underline block font-semibold"
    >
      Change Plan
    </Link>
  </CardFooter>
);

export default React.memo(UpgradeCardFooter);
